import ModalBase, { IModalBaseProps, ModalBaseRefType } from "@/Components/Base/ModalBase";
import { useRef } from "react";
import TituloForm from "./TituloForm";

export interface ITituloCadastroModalModalProps extends IModalBaseProps {
    codigo:number|undefined;
    isAReceber:boolean;
}

export default function TituloCadastroModalModal({
    codigo,
    width,
    textButtonOpen,
    propsButtonOpen,
    footer,
    onClose,
    isAReceber,
    ...props
}:ITituloCadastroModalModalProps) {
    propsButtonOpen = propsButtonOpen ?? {};
    propsButtonOpen.style = propsButtonOpen.style ?? {};
    const isAlteracao = codigo !== undefined && !isNaN(codigo) && codigo > 0;

    const refModal = useRef<ModalBaseRefType|null>(null);

    return <ModalBase
        {...props}
        ref={refModal}
        title={textButtonOpen ?? (isAlteracao ? "Editar" : "Cadastrar")}
        width={width ?? "85vw"}
        textButtonOpen={textButtonOpen ?? "Ver"}
        destroyOnClose={true}
        propsButtonOpen={{
            ...propsButtonOpen,
            type : propsButtonOpen.type ?? "dashed",
            size : propsButtonOpen.size ?? "small",
            style : {
                ...propsButtonOpen.style,
                width : propsButtonOpen.style.width ?? "min-content"
            }
        }}
        footer={footer ?? <></>}
    >
        <TituloForm 
            codigo={codigo}
            isAReceber={isAReceber}
            onCancelar={(ev) => {
                refModal.current?.fechar();
                onClose?.();
            }}
            onSalvarSucesso={(ev) => {
                refModal.current?.fechar();
                onClose?.();
            }}
        />
    </ModalBase>; 
}